(function (section_name) {
  var LETTERS = ['a', 'b', 'c', 'd', 'e'];

  function init() {
    var root = document.querySelector('.' + section_name + ' .q40');
    if (!root) return;

    // Hide native theme chrome (CSS inline style is the source of truth; this is a backup)
    if (root.getAttribute('data-hide-chrome') === 'true') {
      document.body.classList.add('acc-bn-hp-40-hide-chrome');
    }

    // Enable screen cross-fade only AFTER the first paint, so a deep-linked result
    // (?r=) or the entry screen appears instantly on load instead of animating
    // from Q1 -> results (which flashed the first screen).
    requestAnimationFrame(function () { root.classList.add('is-ready'); });

    var emailEnabled = root.getAttribute('data-email') !== 'false';

    function step(n) { return root.querySelector('#q40-step-' + n); }
    function go(n) {
      var el = step(n);
      if (!el) return;
      el.checked = true;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* ---- Auto-advance on the FIRST answer of each question this journey ---- */
    var seen = {};
    root.querySelectorAll('.answer').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var qn = parseInt((input.name || '').replace('q40-q', ''), 10);
        if (!qn || seen[qn]) return;      // revisited question -> use Next button
        seen[qn] = true;
        setTimeout(function () { go(qn === 5 ? 6 : qn + 1); }, 240);
      });
    });

    /* ---- Loading screen (step 6): 3s calm transition, then email or results ---- */
    var loadTimer = null, cycleTimer = null;
    var s6 = step(6);
    if (s6) {
      s6.addEventListener('change', function () {
        if (!s6.checked) return;
        var titles = root.querySelectorAll('.q40-load__title');
        var i = 0;
        titles.forEach(function (t, idx) { t.classList.toggle('is-active', idx === 0); });
        clearInterval(cycleTimer);
        if (titles.length > 1) {
          cycleTimer = setInterval(function () {
            i = (i + 1) % titles.length;
            titles.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
          }, 1000);
        }
        clearTimeout(loadTimer);
        loadTimer = setTimeout(function () {
          clearInterval(cycleTimer);
          go(emailEnabled ? 7 : 8);
        }, 3000);
      });
    }

    /* ---- Email capture (step 7): a NATIVE Shopify customer form (same as the
       theme footer) so Shopify's bot-protection/CAPTCHA runs — but it POSTs into a
       hidden iframe so the main page never reloads. The field's `required`/`type=email`
       gives native validation. On submit we show a loading state; when the iframe
       finishes we reveal the confirmation in place (answers stay in memory, so the
       "See my result" button lands on the right result). ---- */
    var form = root.querySelector('.q40-email__form');
    var frame = root.querySelector('.q40-email__frame');
    var doneEl = root.querySelector('.q40-email__done');
    var inner = root.querySelector('.q40-email__inner');
    if (form && frame) {
      var submitting = false;
      form.addEventListener('submit', function () {
        submitting = true;                              // native validation already passed
        try { sessionStorage.setItem('q40_ans', currentAnswers()); } catch (e) {} // fallback if iframe target is ignored
        var btn = form.querySelector('.q40-email__submit');
        if (btn) btn.classList.add('is-loading');
      });
      frame.addEventListener('load', function () {
        if (!submitting) return;                        // ignore the initial blank load
        submitting = false;
        var ok = true;
        try { ok = /customer_posted=true/.test(frame.contentWindow.location.href); } catch (e) { ok = true; }
        var btn = form.querySelector('.q40-email__submit');
        if (btn) btn.classList.remove('is-loading');
        if (ok) {
          form.setAttribute('hidden', '');
          if (inner) inner.classList.add('is-done');
          if (doneEl) doneEl.removeAttribute('hidden');
        } else {
          var err = form.querySelector('.q40-email__error');
          if (!err) { err = document.createElement('p'); err.className = 'q40-email__error'; form.insertBefore(err, form.firstChild); }
          err.textContent = 'Something went wrong. Please try again.';
        }
      });
    }

    /* ---- History / deep-link: encode all answers on results, restore on load ---- */
    function currentAnswers() {
      var out = '';
      for (var q = 1; q <= 5; q++) {
        var picked = '_';
        for (var k = 0; k < LETTERS.length; k++) {
          var el = root.querySelector('#q40-q' + q + '-' + LETTERS[k]);
          if (el && el.checked) { picked = LETTERS[k]; break; }
        }
        out += picked;
      }
      return out;
    }
    function applyAnswers(code) {
      if (!code || code.length !== 5) return false;
      var any = false;
      for (var q = 1; q <= 5; q++) {
        var letter = code.charAt(q - 1);
        if (LETTERS.indexOf(letter) === -1) continue;
        var el = root.querySelector('#q40-q' + q + '-' + letter);
        if (el) { el.checked = true; any = true; }
      }
      return any;
    }
    function urlWith(code) {
      var url = new URL(window.location.href);
      if (code) url.searchParams.set('r', code); else url.searchParams.delete('r');
      return url.toString();
    }
    function resetAll() {
      root.querySelectorAll('.answer').forEach(function (r) { r.checked = false; });
      seen = {};
      go(1);
    }

    var s8 = step(8);
    if (s8) {
      s8.addEventListener('change', function () {
        if (!s8.checked) return;
        var code = currentAnswers();
        if (code.indexOf('_') === -1) {
          history.pushState({ q40: code }, '', urlWith(code));
        }
      });
    }

    // On load: if ?r= carries a complete answer set, restore results (JS backup;
    // an inline pre-paint script also does this before first paint).
    var params = new URLSearchParams(window.location.search);
    var initial = params.get('r');
    if (initial && applyAnswers(initial)) {
      var s8b = step(8); if (s8b) s8b.checked = true;
    }

    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search);
      var code = p.get('r');
      if (code && applyAnswers(code)) { var e8 = step(8); if (e8) e8.checked = true; }
      else { resetAll(); }
    });

    /* ---- Start over ---- */
    root.querySelectorAll('[data-q40-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        resetAll();
        history.replaceState({}, '', urlWith(null));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    /* ---- Keep section in view when the active step changes ---- */
    root.querySelectorAll('.q40__nav').forEach(function (nav) {
      nav.addEventListener('change', function () {
        var rect = root.getBoundingClientRect();
        if (rect.top < -10 || rect.top > 80) {
          window.scrollTo({ top: rect.top + window.pageYOffset, behavior: 'smooth' });
        }
        // reset scroll position inside the newly shown screen
        var active = root.querySelector('.q40__screen[style], .q40__screen');
        root.querySelectorAll('.q40__screen').forEach(function (s) { s.scrollTop = 0; });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})("acc_bn_hp_40_01");
